module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-c67864f9.png";